import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const CollectionsPage = ({ startDate, endDate }) => {
  const [collections, setCollections] = useState([]);
  const [dailyCollectionByAgent, setDailyCollectionByAgent] = useState({});
  const [weeklyCollectionByAgent, setWeeklyCollectionByAgent] = useState({});
  const baseURL = process.env.REACT_APP_BASE_URL;
  const [dailyTotal, setDailyTotal] = useState(0);
  const [weeklyTotal, setWeeklyTotal] = useState(0);
  const [dailyCount, setDailyCount] = useState(0);
  const [weeklyCount, setWeeklyCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const formatDate = (dateStr) => {
    const [day, month, year] = dateStr.split("-");
    return `${year}-${month}-${day}`;
  };

  console.log("Start Date : ", startDate);
  console.log("End date :", endDate);

  const normalizeName = (name) => name.trim().toLowerCase();

  // Fetch collections from backend
  useEffect(() => {
    const fetchData = async () => {
      try {
        const accessToken = sessionStorage.getItem("access_token");
        const response = await axios.get(`${baseURL}/getAllCollection`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        setCollections(response.data);
        console.log("API Response:", response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  console.log("Start Date:", startDate);
  console.log("End Date:", endDate);
  collections.forEach((collection) => {
    console.log("Collection Date:", collection.date);
  });

  useEffect(() => {
    if (startDate && endDate && collections.length > 0) {
      // Parse dates correctly
      const start = new Date(formatDate(startDate));
      const end = new Date(formatDate(endDate));

      // Filter collections within the date range
      const filteredCollections = collections.filter((collection) => {
        const collectionDate = new Date(collection.date);
        return collectionDate >= start && collectionDate <= end;
      });
      console.log("Collections : ", collections);

      // Separate daily and weekly collections
      const dailyCollections = filteredCollections.filter(
        (collection) =>
          collection.scheme_name?.toLowerCase() === "daily collection"
      );

      const weeklyCollections = filteredCollections.filter(
        (collection) =>
          collection.scheme_name?.toLowerCase() === "weekly collection"
      );

      // Aggregate data
      const dailyData = dailyCollections.reduce((acc, collection) => {
        const agentName = normalizeName(collection.name);
        if (!acc[agentName]) acc[agentName] = { totalAmount: 0, count: 0 };
        acc[agentName].totalAmount +=
          parseFloat(collection.emi_amount.trim()) || 0;
        acc[agentName].count += 1;
        return acc;
      }, {});

      const weeklyData = weeklyCollections.reduce((acc, collection) => {
        const agentName = normalizeName(collection.name);
        if (!acc[agentName]) acc[agentName] = { totalAmount: 0, count: 0 };
        acc[agentName].totalAmount +=
          parseFloat(collection.emi_amount.trim()) || 0;
        acc[agentName].count += 1;
        return acc;
      }, {});

      // Update state
      setDailyCollectionByAgent(dailyData);
      setWeeklyCollectionByAgent(weeklyData);
      setDailyTotal(
        Object.values(dailyData).reduce(
          (acc, item) => acc + item.totalAmount,
          0
        )
      );
      setWeeklyTotal(
        Object.values(weeklyData).reduce(
          (acc, item) => acc + item.totalAmount,
          0
        )
      );
      setDailyCount(
        Object.values(dailyData).reduce((acc, item) => acc + item.count, 0)
      );
      setWeeklyCount(
        Object.values(weeklyData).reduce((acc, item) => acc + item.count, 0)
      );
    }
  }, [startDate, endDate, collections]);

  // Get unique agents
  const allAgents = new Set([
    ...Object.keys(dailyCollectionByAgent),
    ...Object.keys(weeklyCollectionByAgent),
  ]);
  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <p className="text-lg font-semibold text-gray-600">Loading…</p>
      </div>
    );
  }

  return (
    <div className="p-5 bg-gray-50">
      <h2 className="text-lg font-bold mb-3 text-center">Agent Collections</h2>
      <h2 className="text-lg font-bold mb-6 text-center">
        {startDate} to {endDate}
      </h2>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
          <thead className="bg-gray-100">
            <tr>
              <th className="py-2 px-4 text-left">Agent</th>
              <th className="py-2 px-4 text-left">Daily Collection</th>
              <th className="py-2 px-4 text-left">Weekly Collection</th>
            </tr>
          </thead>
          <tbody>
            {Array.from(allAgents).map((agentName, index) => {
              const dailyData = dailyCollectionByAgent[agentName] || {
                totalAmount: 0,
                count: 0,
              };
              const weeklyData = weeklyCollectionByAgent[agentName] || {
                totalAmount: 0,
                count: 0,
              };

              // Apply gray for even rows and white for odd rows
              const rowColor = index % 2 === 0 ? "bg-white" : "bg-gray-100";

              return (
                <tr key={agentName} className={rowColor}>
                  <td className="py-2 px-4">{agentName}</td>
                  <td className="py-2 px-4">
                    {dailyData.totalAmount.toFixed(2)} ({dailyData.count})
                  </td>
                  <td className="py-2 px-4">
                    {weeklyData.totalAmount.toFixed(2)} ({weeklyData.count})
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default CollectionsPage;
